import React, { useState } from 'react'
import { App, } from 'antd'
import { useFeiyongZTXGMutation } from '../../store/DianShangYeWuApi'
import Icon from '../../cpn/Icon'
function ExpenseWithdraw(props) {
    const {message} = App.useApp()
    const [ztxg] = useFeiyongZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    const handleZTXG = () => {
        // 如果正在提交中，直接返回
        if (isSubmitting) {
            return;
        }
        // 设置提交状态
        setIsSubmitting(true);
        ztxg({
            fy_id:props.fy_id,
            fy_state: '1',
        }).then((res) => {
            if(res.data.Status === 'success') {
                message.success('费用单取消提交成功！')
            }else{
                message.error('费用单取消提交失败！'+res.data.Message)
            }
            // 3秒后恢复可点击状态
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        }).catch((err) => {
            // 出错时也要恢复状态
            setTimeout(() => {
                setIsSubmitting(false);
            }, 3000);
        })
    }    
    return (
        <Icon 
            type='withdraw' 
            onClick={() => handleZTXG()} 
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
        />
    )
}

export default ExpenseWithdraw